import React, { useEffect } from "react";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import { Alert, Box, Paper, Snackbar, Tab, Tabs } from "@mui/material";
import { useLocation } from "react-router-dom";
import {
  EquipmentTypeDto,
  ListItemDto,
  RequestQuoteOptionsDto,
} from "api/PricingPlatformApi.generated";
import MtfaTabPanel from "components/global/common/MtfaTabPanel/MtfaTabPanel";
import { useApiContext } from "contexts/ApiProvider";
import ListItemTable from "./ListItemTable";
import EquipmentTypeTable from "./EquipmentTypeTable";
import { useSelector } from "react-redux";

const SettingsManagement = () => {
  const [showToast, setShowToast] = React.useState(false);
  const { state } = useLocation();

  const [equipmentList, setEquipmentList] = React.useState<EquipmentTypeDto[]>(
    []
  );
  const [commodityList, setCommodityList] = React.useState<ListItemDto[]>([]);
  const [specializedServiceList, setSpecializedServiceList] = React.useState<
    ListItemDto[]
  >([]);

  const [tabValue, setTabValue] = React.useState(0);
  const { equipmentApi, commodityApi, specializedServiceApi } = useApiContext();

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    if (state?.officeCreated) {
      setShowToast(state.officeCreated);
    }
  }, [state]);

  const options = useSelector<any, RequestQuoteOptionsDto>(
    (state: any) => state.userRequestReducer.options
  );

  useEffect(() => {
    if (options !== undefined) {
      setEquipmentList(options.equipmentTypes ?? []);
      setCommodityList(options.commodities ?? []);
      setSpecializedServiceList(options.specializedServices ?? []);
    }
  }, [options]);

  const handleCommodityEdit = (item: ListItemDto) => {
    // Implement your edit logic here, e.g., open a dialog for editing
    console.log("Edit commodity:", item);
    // Example:
    // 1. Open a modal/dialog.
    // 2. Populate the dialog with `item` data.
    // 3. On save, call an API to update the commodity.
    // 4. Update the `commodityList` state in SettingsManagement.
  };

  const handleCommodityDelete = (item: ListItemDto) => {
    try {
      // Call your API to delete the commodity
      //await commodityApi.deleteCommodity(item.value); // Assuming your API has a deleteCommodity method that takes the item's ID
      // Update the state to reflect the deletion
      setCommodityList(commodityList.filter((c) => c.value !== item.value));
      // Show success notification
      // dispatch(showNotification({ message: "Commodity deleted successfully", type: "success" }));
      return true;
    } catch (error) {
      console.error("Error deleting commodity:", error);
      // Show error notification
      // dispatch(showNotification({ message: "Error deleting commodity", type: "error" }));
      return false;
    }
  };

  return (
    <Grid size={{ xs: 12 }} width="100%">
      <Paper variant="basePaper">
        <Grid container>
          <Grid size={{ xs: 12 }} mb={2}>
            <Typography variant="h4">Settings</Typography>
          </Grid>
          <Grid size={{ xs: 12 }} mb={2}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Grid size={{ xs: 12 }} container alignItems="center">
                <Grid size={{ xs: 8 }}>
                  <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    aria-label="Settings"
                  >
                    <Tab label="Equipment Types" />
                    <Tab label="Commodities" />
                    <Tab label="Specialized Services" />
                    <Tab label="Reasons Lost" />
                  </Tabs>
                </Grid>
                <Grid
                  container
                  size={{ xs: 4 }}
                  justifyContent="flex-end"
                  direction="row"
                  spacing={0.4}
                >
                  <Grid></Grid>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
        <Grid mt={2} container size={{ xs: 12 }}>
          <MtfaTabPanel value={tabValue} index={0}>
            <EquipmentTypeTable dataList={equipmentList} />
          </MtfaTabPanel>
          {/* <MtfaTabPanel value={tabValue} index={0}>
            <ListItemTable
              dataList={equipmentList}
              onEdit={handleCommodityEdit}
              onDelete={handleCommodityDelete}
            />
          </MtfaTabPanel> */}
          <MtfaTabPanel value={tabValue} index={1}>
            <ListItemTable
              dataList={commodityList}
              onEdit={handleCommodityEdit}
              onDelete={handleCommodityDelete}
            />
          </MtfaTabPanel>
          <MtfaTabPanel value={tabValue} index={2}>
            <ListItemTable dataList={specializedServiceList} />
          </MtfaTabPanel>
          <MtfaTabPanel value={tabValue} index={3}>
            {/* <ListItemTable dataList={options.reasonLostOptions} /> */}
          </MtfaTabPanel>
        </Grid>
      </Paper>
      <Snackbar
        open={showToast}
        autoHideDuration={4000}
        onClose={() => setShowToast(false)}
      >
        <Alert severity="success" sx={{ width: "100%" }}>
          Office created successfully
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default SettingsManagement;
